import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseComponent } from 'src/app/base/base.component';
import DatabaseType, { DataConnector, DataConnectorType, OracleDataConnectorInfo, OracleDataConnector } from 'src/app/domainObjects/dataConnector';
import { IngestConfigViewModel } from 'src/app/views/import-data/import-data.component';
import { ConfigService } from 'src/app/services/config/config.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { DataConnectorViewModel } from 'src/app/viewModels/dataConnectorViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { Time, DatePipe } from '@angular/common';
import { Observable,BehaviorSubject } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { DatabaseConnectorTestConnectionRequest } from '../sql-data-connector/sql-data-connector.component';

export class OracleDataConnectorViewModel extends DataConnectorViewModel<OracleDataConnectorInfo> {
  id: number;
  databaseType: DatabaseType;
  databaseServer: string;
  databaseName: string;
  userName?: string;
  password?: string;
  isIntegratedSecurity = false;
  portNumber?: number;
  driver?: string;
  sqlCommand: string;
  connectionTimeout?:number;
  beginDate?: Date;
  endDate?: Date;
  isConnectionValid = false;
  beginTime?: string;
  endTime?: string;
  timestampField?: string;
  sampleStart?: number=0;
  sampleEnd?: number=1000;
  tableName?: string;
  sqlCodeExtention?: string;
  serviceName: string;
  isBuildConnectionValid = false;

  constructor(dabaseConnector?: OracleDataConnectorInfo) {
    super();
    this.dataConnectorType = DataConnectorType.Database;
    this.databaseType=DatabaseType.Oracle;
    this.portNumber = 1521;  // Ensure portNumber has a default value
    this.connectionTimeout=60;
    if (dabaseConnector) {
      this.beginDate=dabaseConnector.beginDateRange;
      this.endDate=dabaseConnector.endDateRange;
      this.databaseName=dabaseConnector.databaseName;
      this.databaseServer=dabaseConnector.databaseServer;
      this.userName=dabaseConnector.userName;
      this.password=dabaseConnector.password;
      this.sqlCommand=dabaseConnector.sqlCommand;
      this.connectionTimeout=dabaseConnector.connectionTimeOut?? 60;
      this.portNumber = dabaseConnector.portNumber ?? 1521; // Ensure value exists
      this.isIntegratedSecurity=dabaseConnector.isIntegratedSecurity;
      this.driver=dabaseConnector.driver;
      this.beginTime=dabaseConnector.beginTime;
      this.endTime=dabaseConnector.endTime;
      this.timestampField=dabaseConnector.timestampField;
      this.sampleStart=dabaseConnector.sampleStart;
      this.sampleEnd=dabaseConnector.sampleEnd;
      this.tableName=dabaseConnector.tableName;
      this.sqlCodeExtention=dabaseConnector.sqlCodeExtention;
      this.serviceName=dabaseConnector.serviceName;
    }
  }
  validate(): boolean {
    return false;
  }

  toDataConnector(): OracleDataConnector  {
    return new OracleDataConnector(this.id, this.databaseType, this.databaseServer, this.databaseName,this.sqlCommand,this.connectionTimeout,this.isIntegratedSecurity,this.dataSourceType, this.userName,this.password,this.beginDate,this.endDate,this.portNumber, this.driver,this.beginTime,this.endTime, this.timestampField, this.sampleStart, this.sampleEnd, this.tableName, this.sqlCodeExtention);
  }
}

export class DataConnectorTestConnectionRequest {
  dataConnectorType: DataConnectorType;
}
export class OracleDataConnectorTestConnectionRequest extends DataConnectorTestConnectionRequest {
  databaseType: DatabaseType;
  databaseServer: string;
  databaseName: string;
  userName: string;
  password: string;
  sqlText: string;
  serviceName: string;
  portNumber: number;
  tableName:string;
  sqlQuery:string;
}

export class DataConnectorTestConnectionResponse {
  connected: boolean;
  errorMessage?: string;
  warning?: string;
}

@Component({
    selector: 'app-oracle-data-connector',
    templateUrl: './oracle-data-connector.component.html',
    styleUrls: ['./oracle-data-connector.component.css'],
    standalone: false
})
export class OracleDataConnectorComponent extends BaseComponent implements OnInit {

  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;
  @Input() ingestConfigViewModel: IngestConfigViewModel;

  progressBehavior = new BehaviorSubject<boolean>(false);
  DatabaseType = DatabaseType;
  dbForm: FormGroup;
  formGroups: FormGroup[] = [];
  viewModel = new OracleDataConnectorViewModel();

  control = new UntypedFormControl('');
  tablelists: string[] = null;
  tablelistsOptions: Observable<string[]>;
  datetimeField:any=null
 separatorControl:FormControl;
  constructor(
    public datepipe: DatePipe,
    private changeDet: ChangeDetectorRef, 
    private mapperService: ConfigService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    errorReportingService: ErrorReportingService,
    matDialog: MatDialog) {
    super(errorReportingService, matDialog);
  }

  ngOnInit(): void {
    this.dbForm = this.fb.group({
          databaseServer: ['', Validators.required],
          databaseName: ['', Validators.required],
          userName: ['', Validators.required],
          password: ['', Validators.required],
          portNumber: ['', Validators.required]
      });
  
        // Register the form
        this.registerFormGroup(this.dbForm);
    
    this.dataTransformConfigViewModel.oracleDataConnectorViewModel = this.viewModel;   
  }
  
  private _filter(value: string): string[] {
    const filterValue = this._normalizeValue(value);
    return this.tablelists.filter(name => this._normalizeValue(name).includes(filterValue));
  }
  registerFormGroup(group: FormGroup): void {
    if (group) {
        this.formGroups.push(group);
    }
}
  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  ngOnChanges(changes: any) {
    this.viewModel = changes.ingestConfigViewModel?.currentValue.getOracleConnector();
    if (!this.viewModel) {
      this.viewModel = new OracleDataConnectorViewModel();
      this.ingestConfigViewModel.dataConnector = this.viewModel;
    } else {
    }
    if(this.viewModel.tableName.length>0)
      this.getDatetimeField(this.viewModel.tableName);
  }

  async testConnection(): Promise<void> {

    if (this.dbForm.valid) {
      const request = new OracleDataConnectorTestConnectionRequest();
      request.databaseServer = this.viewModel.databaseServer;
      request.databaseType = this.viewModel.databaseType;
      request.userName = this.viewModel.userName;
      request.password = this.viewModel.password;
      request.serviceName = this.viewModel.databaseName;
      request.portNumber = this.viewModel.portNumber;
  
      try {
        this.viewModel.isConnectionValid = false;
        this.progressBehavior.next(true);
        const response = await this.mapperService.testOracleConnectorConnection(request);
        const isConnected = response.connected === 'true';
      
      if (!isConnected) {
        //console.log("if error");
          this.displayError(response.message || 'Connection attempt failed', 'Connection attempt failed');
      } else {
          this.viewModel.isConnectionValid = true;
        // console.log("if sucess");
          this.snackBar.open(`DataConnector connection is working!`, 'Dismiss', {
              duration: 5000
          });
      }
       /* if (response.errorMessage) {
          this.displayError(response.errorMessage, 'Connection attempt failed');
        } else if (response.warning){
          this.displayError(response.warning, 'Connection attempt failed');
        } else {
          this.viewModel.isConnectionValid = true;
          this.snackBar.open(`DataConnector connection is working!`, 'Dismiss', {
            duration: 5000
          });
        }*/
        this.progressBehavior.next(false);
      } catch (err) {
        this.progressBehavior.next(false);
        this.displayError('Failed to test connection', 'Error', err);
      }
    }
    else
    {
      this.dbForm.markAllAsTouched();
      this.changeDet.detectChanges(); // Force UI update
      return;
    }
   
  }

async refreshTableList(): Promise<void> {
  this.viewModel.tableName='';
  this.viewModel.timestampField='';
  this.viewModel.beginDate=new Date();
  this.viewModel.beginTime='';
  this.viewModel.endDate=new Date();
  this.viewModel.endTime='';
  const request = new OracleDataConnectorTestConnectionRequest();

  request.databaseServer = this.viewModel.databaseServer;
  request.databaseType = this.viewModel.databaseType;
  request.userName = this.viewModel.userName;
  request.password = this.viewModel.password;
  request.serviceName = this.viewModel.databaseName;
  request.portNumber = this.viewModel.portNumber;


  try {
    this.viewModel.isConnectionValid = false;
    this.progressBehavior.next(true);
    const response = await this.mapperService.getOracleTableList(request);
    if (response.errorMessage) {
      this.displayError(response.errorMessage, 'Connection attempt failed');
    } else if (response.warning){
      this.displayError(response.warning, 'Connection attempt failed');
    } else {
      this.viewModel.isConnectionValid = true;
      this.snackBar.open(`DataConnector connection is working!`, 'Dismiss', {
        duration: 5000
      });
      //console.log(response);
      this.tablelists=JSON.parse(JSON.stringify(response)).map(table => table.name); 
      this.tablelistsOptions = this.control.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || '')),
      );
      this.changeDet.detectChanges();
      //console.log(this.tablelists);
      
    }
    this.progressBehavior.next(false);
  } catch (err) {
    this.progressBehavior.next(false);
    this.displayError('Failed to test connection', 'Error', err);
  }
}

async getDatetimeField(tablename,isManualTrigger: boolean = false): Promise<void> {


 // console.log('isManualTrigger==:', isManualTrigger);
  const request = new OracleDataConnectorTestConnectionRequest();
      request.databaseServer = this.viewModel.databaseServer;
      request.databaseType = this.viewModel.databaseType;
      request.userName = this.viewModel.userName;
      request.password = this.viewModel.password;
      request.serviceName = this.viewModel.databaseName;
      request.portNumber = this.viewModel.portNumber;
      request.tableName= this.viewModel.tableName;

  try {
    this.viewModel.isConnectionValid = isManualTrigger;
    this.progressBehavior.next(true);
    const response = await this.mapperService.getOracleDatetimeField(request,tablename);
    // Clear previous data
     this.datetimeField = [];
    if (response.errorMessage) {
      this.displayError(response.errorMessage, 'Connection attempt failed');
    } else if (response.warning) {
      this.displayError(response.warning, 'Connection attempt failed');
    } else if (!Array.isArray(response) || response.length === 0) {
      // Check if response is not an array OR if it's an empty array
      this.snackBar.open('No Timestamp Fields found!', 'Dismiss', {
        duration: 5000
      });
    } else {
      // Success case when response is a non-empty array
      if(isManualTrigger===true)
      this.snackBar.open(`Timestamp Fields have been retrieved!`, 'Dismiss', {
        duration: 5000
      });
    
      this.datetimeField = response;
      this.changeDet.detectChanges();
    }
    this.progressBehavior.next(false);
  } catch (err) {
    this.progressBehavior.next(false);
    this.displayError('Failed to test connection', 'Error', err);
  }
}

private formatDateTime(date: Date): string {
  const pad = (num: number) => num.toString().padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
         `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${date.getMilliseconds().toString().padStart(6, '0')}`;
}
async BuildQuery() {
  try {
    // Check if table name is provided
    if (!this.viewModel.tableName) {
      this.snackBar.open(`Table name is missing.`, 'Dismiss', { duration: 5000 });
      this.progressBehavior.next(false);
      return;
    }

    let sqlquery = `SELECT * FROM ${this.viewModel.tableName}`;
    let sqlquerycount = `SELECT COUNT(1) AS total_rows FROM ${this.viewModel.tableName}`;
    let hasWhereClause = false;

    if (this.viewModel.timestampField) {
      // Format start date and time
      let startDate = new Date(this.viewModel.beginDate);
      let startTimeParts = this.parseTime(this.viewModel.beginTime);
      startDate.setHours(startTimeParts.hours, startTimeParts.minutes, 0, 0);
      let startFormattedDateTime = this.formatDateTime(startDate);

      // Format end date and time
      let endDate = new Date(this.viewModel.endDate);
      let endTimeParts = this.parseTime(this.viewModel.endTime);
      endDate.setHours(endTimeParts.hours, endTimeParts.minutes, 59, 999);
      let endFormattedDateTime = this.formatDateTime(endDate);

      // Construct dynamic SQL for timestamps
      sqlquery += ` WHERE ${this.viewModel.timestampField} >= TO_TIMESTAMP('${startFormattedDateTime}', 'YYYY-MM-DD HH24:MI:SS.FF6') AND ${this.viewModel.timestampField} < TO_TIMESTAMP('${endFormattedDateTime}', 'YYYY-MM-DD HH24:MI:SS.FF6')`;

      sqlquerycount += ` WHERE ${this.viewModel.timestampField} >= TO_TIMESTAMP('${startFormattedDateTime}', 'YYYY-MM-DD HH24:MI:SS.FF6') AND ${this.viewModel.timestampField} < TO_TIMESTAMP('${endFormattedDateTime}', 'YYYY-MM-DD HH24:MI:SS.FF6')`;

      hasWhereClause = true;
    }

    // Append additional SQL conditions if present
    if (this.viewModel.sqlCodeExtention) {
      sqlquery += (hasWhereClause ? " AND " : " WHERE ") + this.viewModel.sqlCodeExtention;
    }


    // Add ORDER BY only if timestampField exists
if (this.viewModel.timestampField) {
  sqlquery += ` ORDER BY ${this.viewModel.timestampField}`;
} else {
  sqlquery += ` ORDER BY 1`;  // Default to a constant (1) to avoid syntax errors
}

// Add pagination
sqlquery += ` OFFSET ${this.viewModel.sampleStart} ROWS FETCH NEXT ${this.viewModel.sampleEnd - this.viewModel.sampleStart} ROWS ONLY`;

    // Add pagination
    //sqlquery += ` ORDER BY ${this.viewModel.timestampField} OFFSET ${this.viewModel.sampleStart} ROWS FETCH NEXT ${this.viewModel.sampleEnd - this.viewModel.sampleStart} ROWS ONLY`;

    // Assign to ViewModel
    this.viewModel.sqlCommand = sqlquery;
    this.viewModel.isBuildConnectionValid = true;

    // Create request object
    const request = new OracleDataConnectorTestConnectionRequest();
    request.databaseServer = this.viewModel.databaseServer;
    request.databaseType = this.viewModel.databaseType;
    request.userName = this.viewModel.userName;
    request.password = this.viewModel.password;
    request.serviceName = this.viewModel.databaseName;
    request.portNumber = this.viewModel.portNumber;
    request.sqlQuery = sqlquerycount;

    this.viewModel.isConnectionValid = false;
    this.progressBehavior.next(true);

    // Execute query and handle response
    const response = await this.mapperService.orcacleTableRowCount(request);
    if (response.errorMessage) {
      this.displayError(response.errorMessage, 'Connection attempt failed');
    } else if (response.warning) {
      this.displayError(response.warning, 'Connection attempt failed');
    } else {
      this.viewModel.isConnectionValid = true;
      if (response.isrecordsmorethan1million === 'true') {
        this.snackBar.open(`The current query will return more than 1,000,000 rows`, 'Dismiss', { duration: 5000 });
      }
    }

    this.progressBehavior.next(false);

  } catch (err) {
    this.progressBehavior.next(false);
    this.viewModel.isBuildConnectionValid = false;
    this.displayError('Failed to build query', 'Error', err);
  }
}


 /* async BuildQuery() {
  try {


      // If table name is missing, show snackbar message and exit the function
      if (!this.viewModel.tableName) {
        this.snackBar.open(`Table name is missing.`, 'Dismiss', {
          duration: 5000
        });
        this.progressBehavior.next(false);
        return; // Exit the function early
      }

    //this.progressBehavior.next(true);

   
    // Construct SQL Query
   // let sqlquery = `SELECT * FROM ${this.viewModel.tableName} WHERE ${this.viewModel.timestampField} BETWEEN TO_DATE('${startFormattedDateTime}', 'YYYY-MM-DD HH24:MI:SS') AND TO_DATE('${endFormattedDateTime}', 'YYYY-MM-DD HH24:MI:SS')`;

    // Append additional SQL extension if provided
    //if (this.viewModel.sqlCodeExtention) {
     // sqlquery += ` ${this.viewModel.sqlCodeExtention}`;
    //}

    // Add pagination
    //sqlquery += ` ORDER BY 1 OFFSET ${this.viewModel.sampleStart} ROWS FETCH NEXT ${this.viewModel.sampleEnd - this.viewModel.sampleStart} ROWS ONLY`;

    let sqlquery = `SELECT * FROM ${this.viewModel.tableName}`;
    let sqlquerycount = `SELECT COUNT(1) AS total_rows FROM ${this.viewModel.tableName}`;
    let hasWhereClause = false;
    
    if (this.viewModel.timestampField) {

       // Format start date and time
    let startDate = new Date(this.viewModel.beginDate);
    let startTimeParts = this.parseTime(this.viewModel.beginTime);
    startDate.setHours(startTimeParts.hours, startTimeParts.minutes, 0, 0);
    let startFormattedDateTime = this.formatDate(startDate);

    // Format end date and time
    let endDate = new Date(this.viewModel.endDate);
    let endTimeParts = this.parseTime(this.viewModel.endTime);
    endDate.setHours(endTimeParts.hours, endTimeParts.minutes, 0, 0);
    let endFormattedDateTime = this.formatDate(endDate);


    
     //sqlquery += ` WHERE ${this.viewModel.timestampField} >= TO_TIMESTAMP('${startFormattedDateTime}', 'YYYY-MM-DD HH24:MI:SS') AND ${this.viewModel.timestampField} < TO_TIMESTAMP('${endFormattedDateTime.substring(0, 16)}:59.999999', 'YYYY-MM-DD HH24:MI:SS.FF6') `;
      sqlquery += `WHERE ${this.viewModel.timestampField} >= TO_TIMESTAMP('${startFormattedDateTime}', 'YYYY-MM-DD HH24:MI:SS.FF6') AND ${this.viewModel.timestampField} < TO_TIMESTAMP('${startFormattedDateTime}', 'YYYY-MM-DD HH24:MI') || ':59.999999' `;


    hasWhereClause = true;
   
        //sqlquerycount += ` WHERE ${this.viewModel.timestampField} BETWEEN TO_TIMESTAMP('${startFormattedDateTime}', 'YYYY-MM-DD HH24:MI:SS') AND TO_TIMESTAMP('${endFormattedDateTime}', 'YYYY-MM-DD HH24:MI:SS') + INTERVAL '0.999999' SECOND`;
      //  sqlquerycount += ` WHERE ${this.viewModel.timestampField} >= TO_TIMESTAMP('${startFormattedDateTime}', 'YYYY-MM-DD HH24:MI:SS') AND ${this.viewModel.timestampField} < TO_TIMESTAMP('${endFormattedDateTime.substring(0, 16)}:59.999999', 'YYYY-MM-DD HH24:MI:SS.FF6') `;
      sqlquerycount += `WHERE ${this.viewModel.timestampField} >= TO_TIMESTAMP('${startFormattedDateTime}', 'YYYY-MM-DD HH24:MI:SS.FF6') AND ${this.viewModel.timestampField} < TO_TIMESTAMP('${startFormattedDateTime}', 'YYYY-MM-DD HH24:MI') || ':59.999999' `;
      
      }
    
    if (this.viewModel.sqlCodeExtention) {
        sqlquery += (hasWhereClause ? " AND " : " WHERE ") + this.viewModel.sqlCodeExtention;
    }
    
    sqlquery += ` ORDER BY ${this.viewModel.timestampField} OFFSET ${this.viewModel.sampleStart} ROWS FETCH NEXT ${this.viewModel.sampleEnd - this.viewModel.sampleStart} ROWS ONLY`;
    
    // Assign to ViewModel
    this.viewModel.sqlCommand = sqlquery;
    this.viewModel.isBuildConnectionValid = true;
    const request = new OracleDataConnectorTestConnectionRequest();

  request.databaseServer = this.viewModel.databaseServer;
  request.databaseType = this.viewModel.databaseType;
  request.userName = this.viewModel.userName;
  request.password = this.viewModel.password;
  request.serviceName = this.viewModel.databaseName;
  request.portNumber = this.viewModel.portNumber;
  request.sqlQuery=sqlquerycount;

    this.viewModel.isConnectionValid = false;
    this.progressBehavior.next(true);

    const response = await this.mapperService.orcacleTableRowCount(request);
    if (response.errorMessage) {
        this.displayError(response.errorMessage, 'Connection attempt failed');
    } else if (response.warning) {
        this.displayError(response.warning, 'Connection attempt failed');
    } else {
        this.viewModel.isConnectionValid = true;
        if (response.isrecordsmorethan1million === 'true') {
          this.snackBar.open(`The current query will return more than 1,000,000 rows`, 'Dismiss', {
            duration: 5000
          });
        }
       
    }

    this.progressBehavior.next(false);

  } catch (err) {
    this.progressBehavior.next(false);
    this.viewModel.isBuildConnectionValid = false;
    this.displayError('Failed to build query', 'Error', err);
  }
}
*/
parseTime(timeStr: string): { hours: number, minutes: number } {
  let timeRegex = /(\d+):(\d+) (AM|PM)/;
  let match = timeStr.match(timeRegex);

  if (!match) return { hours: 0, minutes: 0 }; // Default

  let hours = parseInt(match[1]);
  let minutes = parseInt(match[2]);
  let period = match[3];

  // Convert 12-hour format to 24-hour format
  if (period === "PM" && hours !== 12) hours += 12;
  if (period === "AM" && hours === 12) hours = 0;

  return { hours, minutes };
}

// Format a Date object into yyyy-MM-dd HH:mm:ss
formatDate(date: Date): string {
  let yyyy = date.getFullYear();
  let MM = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  let dd = String(date.getDate()).padStart(2, '0');
  let HH = String(date.getHours()).padStart(2, '0');
  let mm = String(date.getMinutes()).padStart(2, '0');
  let ss = String(date.getSeconds()).padStart(2, '0');

  return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
}


/*onDateChange(event: any): void {
  const now = new Date(); // Current date and time
  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);
  
  // Set yesterday's time to 00:00:00
  yesterday.setHours(0, 0, 0, 0);
  
  // Set today's time to 23:59:59
  now.setHours(23, 59, 59, 999);

  // Set the beginDate and endDate in the viewModel
  this.viewModel.beginDate = yesterday;
  this.viewModel.endDate = now;
 this.viewModel.beginTime = "12:00 AM"; // 12:00 AM
 this.viewModel.endTime = "12:00 AM";  // Set 1:00 AM as default time
}*/
// Function to handle selection change
async onDateChange(selectedValue: string): Promise<void> {
 // console.log('isManualTrigger==:', isManualTrigger);

  // Validate selected field to avoid SQL injection risks
  if (!selectedValue) {
    console.error("Invalid timestamp field selected.");
    return;
  }

// Dynamically construct SQL query with table and column for Oracle

//const sqlQuery = `SELECT MAX(DB_INSERT_DATE) AS recent_datetime FROM T_USERS`;
const sqlQuery = `SELECT MAX(${selectedValue}) AS recent_datetime FROM ${this.viewModel.tableName}`;

 

  const request = new OracleDataConnectorTestConnectionRequest();

  request.databaseServer = this.viewModel.databaseServer;
  request.databaseType = this.viewModel.databaseType;
  request.userName = this.viewModel.userName;
  request.password = this.viewModel.password;
  request.serviceName = this.viewModel.databaseName;
  request.portNumber = this.viewModel.portNumber;
  request.sqlQuery=sqlQuery;

  // Start progress indicator
  this.viewModel.isConnectionValid = true;
  this.progressBehavior.next(true);

  try {
    const response = await this.mapperService.oracleMostRecentDate(request);
    this.viewModel.beginDate = new Date(response.recentDate);
    const enddate = new Date(response.recentDate);
    enddate.setDate(enddate.getDate() + 1);
    this.viewModel.endDate = enddate;
   this.viewModel.beginTime = response.recentTime; // 12:00 AM
   this.viewModel.endTime = response.recentTime; ;  // Set 1:00 AM as default time
   
  } catch (error) {
    console.error("Error while executing SQL query:", error);
    this.displayError("An unexpected error occurred", "Query Execution Failed");
  } finally {
    // Stop progress indicator
    this.progressBehavior.next(false);
  }
}

}


